import { ItemCode } from './itemInfos';
import { Quest, QuestStep, QuestType, UnlockChallengeType, UnlockSteps } from './unlockModels';

export enum TimeLimitedQuestCode {
	Xmas2021,
	Xmas2022,
	Cny2023,
	AprilFool,
	Halloween2023,
	XmasPenguin,
	Cny2024,
}

export const eventTimes: Array<[number, number]> = [];
eventTimes[TimeLimitedQuestCode.Xmas2021] = [1703174400000, 1704815999999];
eventTimes[TimeLimitedQuestCode.Xmas2022] = [1703174400000, 1704815999999];
eventTimes[TimeLimitedQuestCode.Cny2023] = [1674230400000, 1675180799999];
eventTimes[TimeLimitedQuestCode.AprilFool] = [1711879200000, 1712051999999]; // 31/3:1800 ~ 2/4 17:59
eventTimes[TimeLimitedQuestCode.Halloween2023] = [1698508800000, 1699113599999];
eventTimes[TimeLimitedQuestCode.XmasPenguin] = [1703174400000, 1706716799999];
eventTimes[TimeLimitedQuestCode.Cny2024] = [1706976000000, 1708271999999];

export function hasQuestTimeStarted(code: TimeLimitedQuestCode) {
	const ct = Date.now();
	const time = eventTimes[code];
	if (!time) { return false; }
	return ct >= time[0];
}
export function isQuestTime(code: TimeLimitedQuestCode) {
	const ct = Date.now();
	const time = eventTimes[code];
	if (!time) { return false; }
	return ct >= time[0]! && ct <= time[1];
}
export function isTimeQuestTime(ct: number, code: TimeLimitedQuestCode) {
	const time = eventTimes[code];
	if (!time) { return false; }
	return ct >= time[0]! && ct <= time[1];
}

export const timeLimitedQuests: Quest[] = [];

function setQuest(questTitle: string, questSteps: QuestStep[]) {
	const missionCode = questSteps[0].challenges[0].unlockId;
	for (let i = 0; i < questSteps.length; i++) {
		const req = questSteps[i].challenges;
		for (let k = 0; k < req.length; k++) {
			const cha = req[k];
			cha.isMaster = false;
			cha.step = i;
			cha.index = k;
			cha.unlockId = missionCode;
		}
	}
	timeLimitedQuests[missionCode] = {
		code: missionCode,
		title: questTitle,
		type: QuestType.TimeLimited,
		steps: questSteps,
		startTime: eventTimes[missionCode][0],
		endTime: eventTimes[missionCode][1],
	};
}

let steps: QuestStep[];
const index = 0;
let unlockId;
let title;
unlockId = TimeLimitedQuestCode.Xmas2021;
title = 'We Wish you a Stabby Christmas!';
steps = [
	{
		rewards: [{ itemCode: ItemCode.SantaHat, amount: 3 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Accumulate,
				goal: 1,
				description: `Send Love Emoji to Theodore the Polar Bear in the safe zone.`,
			},
		],
	},
	{
		rewards: [{ itemCode: ItemCode.BpCandyStick, amount: 3 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Accumulate,
				goal: 5,
				description: `Send Love Emoji to other players (with name) while wearing a Santa Hat x5`,
			},
		],
	},
	{
		rewards: [{ itemCode: ItemCode.BpReindeerHeadband, amount: 1 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Accumulate,
				goal: 1,
				description: `Send Love Emoji to your teammate while wearing a Santa Hat`,
			},
		],
	},
	{
		rewards: [{ itemCode: ItemCode.BpStarLantern, amount: 1 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.OneGame,
				goal: 100,
				description: `Jump out of the water and reach the star while wearing a Santa Hat.`,
			},
		],
	},
	{
		rewards: [{ itemCode: ItemCode.BpRedNose, amount: 1 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Accumulate,
				goal: 10000,
				description: `Score 10000 points while wearing a Reindeer Headband.`,
			},
		],
	},
	{
		rewards: [{ itemCode: ItemCode.StarLantern, amount: 1 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.OneGame,
				goal: 100,
				description: `Jump out of the water and reach the star while wearing a Reindeer Headband and a Red Nose.`,
			},
		],
	},

];
setQuest(title, steps);

unlockId = TimeLimitedQuestCode.Xmas2022;
title = 'Let it Snow!';
steps = [
	{
		rewards: [{ itemCode: ItemCode.BpSantaHat, amount: 1 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Accumulate,
				goal: 1,
				description: `Buy the Mercy Staff from Theodore the Polar Bear in the safe zone.`,
			},
		],
	},
	{
		rewards: [{ itemCode: ItemCode.BpSantaBeard, amount: 1 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Accumulate,
				goal: 5,
				description: `Release 5 of your stabbed victims using the Mercy Staff while wearing a Santa Hat`,
			},
		],
	},
	{
		rewards: [{ itemCode: ItemCode.SantaBeard, amount: 1 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Accumulate,
				goal: 1,
				description: `Jump into the air and release 3 stabbed victims at once while wearing a Santa Hat`,
			},
		],
	},
];
setQuest(title, steps);


unlockId = TimeLimitedQuestCode.Cny2023;
title = 'Stabby Lunar New Year!';
steps = [
	{
		rewards: [{ itemCode: ItemCode.Money, amount: 8888 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Accumulate,
				goal: 1,
				description: `Play the game during Lunar New Year event to enjoy double gold earning from loot!`,
			},
		],
	},
	{
		rewards: [{ itemCode: ItemCode.RedPacket, amount: 3 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Accumulate,
				goal: 1,
				description: `Say 'Gong Xi Fa Cai' or 'Happy Lunar new Year' to Theodore the Polar Bear and the players in the safe zone!`,
			},
		],
	},
	{
		rewards: [{ itemCode: ItemCode.BpRabbitEarsHeadband, amount: 1 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Accumulate,
				goal: 1,
				description: `Wear a Red Packet to enjoy 50% Additional Gold from loot during Lunar New Year Event!`,
			},
		],
	},

];
setQuest(title, steps);


unlockId = TimeLimitedQuestCode.Halloween2023;
title = 'Zompkin Attack!';
steps = [
	{
		rewards: [{ itemCode: ItemCode.JackOLanternJaw, amount: 1 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Accumulate,
				goal: 10,
				description: `Kill 10 Zompkin-infected fish!`,
			},
		],
	},
	{
		rewards: [{ itemCode: ItemCode.JackOLantern, amount: 1 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Accumulate,
				goal: 20,
				description: `Infect 20 fish with Zompkin!`,
			},
		],
	},

];
setQuest(title, steps);


unlockId = TimeLimitedQuestCode.XmasPenguin;
title = 'Penguin Dinner!';
steps = [
	{
		rewards: [{ itemCode: ItemCode.Gem, amount: 15 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Boss,
				goal: 1,
				description: `Defeat 1★ Mechguin V-55`,
			},
		],
	},
	{
		rewards: [{ itemCode: ItemCode.Gem, amount: 25 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Boss,
				goal: 1,
				description: `Defeat 2★ Mechguin V-55`,
			},
		],
	},
	{
		rewards: [{ itemCode: ItemCode.Gem, amount: 50 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Boss,
				goal: 1,
				description: `Defeat 3★ Mechguin V-55`,
			},
		],
	},
];
setQuest(title, steps);

unlockId = TimeLimitedQuestCode.Cny2024;
title = 'Stabby Lunar New Year!';
steps = [
	{
		rewards: [{ itemCode: ItemCode.Money, amount: 8888 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Accumulate,
				goal: 1,
				description: `Play the game during Lunar New Year event to enjoy double gold earning from loot!`,
			},
		],
	},
	{
		rewards: [{ itemCode: ItemCode.RedPacket, amount: 3 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Accumulate,
				goal: 1,
				description: `Say 'Gong Xi Fa Cai' or 'Happy Lunar new Year' to Theodore the Polar Bear and the players in the safe zone!`,
			},
		],
	},
	{
		rewards: [{ itemCode: ItemCode.DragonHorns, amount: 1 }],
		challenges: [
			{
				unlockId,
				index,
				step: 0,
				type: UnlockChallengeType.Accumulate,
				goal: 1,
				description: `Wear a Red Packet to enjoy 50% Additional Gold from loot during Lunar New Year Event!`,
			},
		],
	},

];
setQuest(title, steps);
